/**
 * 認証エラーモーダル
 */

const authorizationErrorDialog = {
  namespaced: true,
  state: {
    show: false,
    message: null,
  },
  actions: {
    hide ({ commit }) {
      commit('hide')
    },
  },
  mutations: {
    showMessage (state, { message }) {
      state.show = true
      state.message = message
    },
    hide (state) {
      state.show = false
      state.message = null
    }
  },
}
export default authorizationErrorDialog
